import { ref, watch } from "vue";

export const hiddenErrorsService = (() => {
	const savedHiddenErrors = restoreHiddenErrors();
	const hiddenErrors = ref<Set<string>>(new Set(savedHiddenErrors));

	const hideError = (url: string) => {
		hiddenErrors.value.add(url);
	};

	const unhideError = (url: string) => {
		hiddenErrors.value.delete(url);
	};

	watch(hiddenErrors.value, (newHiddenErrors: Set<string>) => {
		saveHiddenErrors([...newHiddenErrors]);
	});

	return {
		hiddenErrors,
		hideError,
		unhideError,
	};
})();

function saveHiddenErrors(errors: string[]) {
	localStorage.setItem("hiddenErrors", JSON.stringify(errors));
}

function restoreHiddenErrors(): string[] {
	const errors = localStorage.getItem("hiddenErrors");
	return errors ? JSON.parse(errors) : [];
}
